import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_COFFEE_RECENT_SUPPORTERS_BY_COUNTRY = createFcmConfig('coffee_recent_supporters_by_country', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
